import React from 'react';
import { Store } from '@/lib/types';
import { getCitiesByState } from '@/lib/utils';
import {
  Badge,
  Card,
  CardContent
} from "@geely/ui";
import { Building2 } from 'lucide-react';

interface CitySelectorProps {
  stores: Store[];
  selectedState: string;
  selectedCity: string;
  onSelectCity: (city: string) => void;
}

export function CitySelector({
  stores,
  selectedState,
  selectedCity,
  onSelectCity
}: CitySelectorProps) {
  const cities = getCitiesByState(stores, selectedState);

  return (
    <div className="space-y-3">
      <h3 className="font-medium text-[#080404]">Selecione a Cidade</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {cities.map(city => {
          const cityStores = stores.filter(
            s => s.state === selectedState && s.city === city
          );
          const isSelected = selectedCity === city;

          return (
            <Card
              key={city}
              className={`cursor-pointer transition-all hover:shadow-md ${
                isSelected
                  ? 'border-[#000000] border-2 bg-[#000000]/5'
                  : 'border-[#e2e8f0] hover:border-[#000000]/30'
              }`}
              onClick={() => onSelectCity(city)}
            >
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                      isSelected ? 'bg-[#000000]' : 'bg-[#e2e8f0]'
                    }`}>
                      <Building2 className={`size-5 ${
                        isSelected ? 'text-white' : 'text-[#64748b]'
                      }`} />
                    </div>
                    <div>
                      <p className={`font-semibold ${
                        isSelected ? 'text-[#000000]' : 'text-[#080404]'
                      }`}>
                        {city}
                      </p>
                    </div>
                  </div>
                  <Badge variant="outline" className="text-xs">
                    {cityStores.length} {cityStores.length === 1 ? 'loja' : 'lojas'}
                  </Badge>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
